import { useEffect , useState } from 'react';
import "./App.css";
import React from 'react';

import Navber from "./components/navber";
import Intro from "./components/intro/intro";
import Preloader from "./components/preloder";
import Skills from "./components/skills/skills";
import Works from "./components/works/works";
import Contact from "./components/contact/contact";
import About from "./components/about/about";
import Footer from "./components/footer/footer";

// import AnimatedCursor from "react-animated-cursor";
import { FloatingWhatsApp } from 'react-floating-whatsapp';
// import Avatar	from './assets/profile.png';


const Avatar= "https://res.cloudinary.com/dmnpdzcvd/image/upload/v1744653002/profile_jflf7p.png";

function App() {

  const [isloading, setIsloading] = useState(true);

useEffect(() => {
  const fetchloader = () => {
    setTimeout(() => {
      setIsloading(false);
    }, 3000);
  };
  fetchloader();
}, []);

  return isloading ? (
    <Preloader />
  ) : (
    <div className="App">
{/* 
    <AnimatedCursor
  innerSize={6}
  outerSize={30}
  innerScale={1}
  outerScale={1.7}
  outerAlpha={0}
  outerStyle={{
    background: 'var(--cursor-color)'

  }}
  innerStyle={{
    border: '2px solid var(--cursor-color)'
  }}
/> */}
         <Navber />

{/* messenger chat bot */}
<FloatingWhatsApp phoneNumber="+88 01772010108" 
accountName="Support"
 placeholder="Type a message.."
 allowEsc
        allowClickAway
        notification
        notificationSound
        avatar={Avatar}
 />
         
      <div className="bg">
        <Intro />
      </div>

      <Skills />
      <Works />
      <About />
      <Contact />
      <Footer />
      
    </div>
  );
}

export default App;
